/*
 * Copyright (c) Schrocken Inc.
 * Author: Harish, Karthik
 * File Description: Types file for all actions
 */

//Auth action
export const USER_LOGIN = 'user_login';
export const ADMIN_SIGNUP = 'admin_signup';
export const PASSWORD_CRITERIA = 'password_criteria';
export const INVITED_USER = 'invited_user';

//invite user action
export const VERIFY_INVITE_USER = 'invited_user_data';
export const SEND_EMAIL_INVITE = 'send_email_invite';
export const SEND_OTP = 'sendOtp';
export const VERIFY_OTP = 'verifyOtp';
export const FETCH_AUTH_DETAILS = 'fetchTwoStepAuthDetails';
export const GET_ISSUE_TYPE = 'getIssueType';

// logout
export const USER_LOGOUT = 'USER_LOGOUT';

//usersAction
export const RESET_USER_PASSWORD = 'reset_user_password';
export const RESET_PASS_TOKEN_DETAILS = 'Rest_Pass_Token_Details';
export const RESET_PASSWORD_FINAL = 'reset_password_final';
export const REQUEST_CONTACT_ADMIN = 'request_contact_admin';
export const SESSION_TIMEOUT = 'session_timeout';
export const SESSION_TIMEOUT_SETTINGS = 'session_timeout_settings';

//ecosystem actions
export const GET_MOSYMPHONY_SETTINGS = 'get_mosymphony_settings';
export const UPDATE_MOSYMPHONY_SETTINGS = 'update_mosymphony_settings';
export const RESET_MOSYMPHONY_SETTINGS = 'reset_mosymphony_settings';
export const ADD_ORGANIZATION = 'add_organization';
export const GET_ORGANIZATION = 'get_organization';
export const COLLABORATOR_TYPE = 'collaborator_type';
export const COLLABORATOR_ROLE = 'collaborator_role';
export const ECOSYSTEM_TYPE = 'ecosystem_type';
export const GET_ECOSYSTEMS = 'get_ecosystems';
export const SEND_BRAND_OWNER_INVITATION = 'send_brand_owner_invitation';

// Errors
export const SERVER_ERROR = 'server_error';

//-------**--V2.0 User and Org Profile--**--------------
export const USER_PROFILE = 'user_profile';
export const ORG_PROFILE = 'org_profile';
export const UPDATE_USER_PROFILE = 'update_user_profile';
export const UPDATE_ORG_PROFILE = 'update_org_profile';
export const UPDATE_PROFILE_FIELD = 'update_profile_field';

//----Department-----//
export const FETCH_DEPARTMENT_DETAILS = 'fetch_department_details';   
export const UPDATE_DEPARTMENT_DETAILS = 'update_department_details';
export const FETCH_DEPARTMENT_DETAILS_LOADING = 'fetch_department_details_loading';
export const FETCH_USERFROM_DEPT = 'fetch_userfrom_dept'; 
export const FETCH_USERFROM_DEPT_LOADING = 'fetch_userfrom_dept_loading'; 
export const FETCH_NETWORK_TYPES = 'fetch_network_types';
export const FETCH_NETWORK_TYPES_LOADING = 'fetch_network_types_loading';
export const FETCH_COLLABORATOR_TYPE = 'fetch_collaborator_type';
export const FETCH_COLLABORATOR_TYPE_LOADING = 'fetch_collaborator_type_loading';
export const UPDATE_NETWORK_DETAILS = 'update_network_details';
export const UPDATE_PARTNER_DETAILS = 'update_partner_details';
export const ADD_NETWORK_DETAILS = 'add_network_details';
export const ADD_PARTNER_DETAILS = 'add_partner_details';
export const DELETE_NETWORK_TYPE='delete_network_type';
export const DELETE_PARTNER_TYPE='delete_partner_type';
export const GET_NETWORK_ROLES = 'get_network_roles';
export const GET_NETWORK_ROLES_LOADING = 'get_network_roles_LOADING';
export const ADD_SPONSOR_NETWORK_DETAILS = 'add_sponsor_network_details';
export const FETCH_ALL_SPONSOR_NETWORKS = 'fetch_all_sponsor_networks';
export const FETCH_ALL_SPONSOR_NETWORKS_LOADING = 'fetch_all_sponsor_networks_loading';
export const FETCH_SELECTED_SPONSOR_DETAILS = 'fetch_selected_sponsor_details';
export const FETCH_SELECTED_SPONSOR_DETAILS_LOADING = 'fetch_selected_sponsor_details_loading';
export const SEND_NETWORK_INVITATION = 'send_network_invitation';
export const UPDATE_SPONSOR_NETWORK_DETAILS='update_sponsor_network_details';
export const SAVE_NETWORK_CONFIGURATION_PROGRESS = 'save_network_configuration_progress';